const { createBrandAdInitializer, preloadAdScripts } = require('./adInitializer');
const { createArticleDesktopAds } = require('./articleDesktopAdsFactory');
const { createArticleMobileAds } = require('./articleMobileAdsFactory');
const { createHomepageDesktopAds } = require('./homepageDesktopAdsFactory');
const { createHomepageMobileAds } = require('./homepageMobileAdsFactory');
const { prefetchStudyAssignments } = require('./lib/insights/study');
const { whenLoginWallDecided } = require('./lib/loginWall');

function createBrandAds(options = {}) {
  const {
    brandConfig,
    logLabel,
    articleTargeting = {},
    homepageTargeting = {},
    resultsPageBaseUrl
  } = options;

  if (!brandConfig || !brandConfig.brand) {
    throw new Error('createBrandAds requires a brandConfig with a brand name.');
  }

  const articleOptions = {
    targeting: articleTargeting,
    resultsPageBaseUrl
  };

  const homepageOptions = {
    targeting: homepageTargeting
  };

  const initArticleDesktopAds = createArticleDesktopAds(brandConfig, articleOptions);
  const initArticleMobileAds = createArticleMobileAds(brandConfig, articleOptions);
  const initArticleTabletAdsHandler = createArticleDesktopAds(brandConfig, { ...articleOptions, device: 'tablet' });
  const initHomepageDesktopAds = createHomepageDesktopAds(brandConfig, homepageOptions);
  const initHomepageMobileAds = createHomepageMobileAds(brandConfig, homepageOptions);

  const initAds = createBrandAdInitializer(
    brandConfig.brand,
    {
      articleDesktop: initArticleDesktopAds,
      articleMobile: initArticleMobileAds,
      articleTablet: initArticleTabletAdsHandler,
      homepageDesktop: initHomepageDesktopAds,
      homepageMobile: initHomepageMobileAds
    },
    { logLabel, loginWallVerdict: whenLoginWallDecided }
  );

  function preloadAds(userConfig = {}) {
    preloadAdScripts(userConfig);
    // Ad init waits for the study assignment; ask now, with the ad scripts.
    prefetchStudyAssignments(brandConfig.brand);
  }

  return {
    initAds,
    preloadAds
  };
}

module.exports = {
  createBrandAds
};
